import { PlaceholderModel } from './Placeholder.model';
import { useTranslation } from 'react-i18next';

const PlaceholderWidget = ({
  title = '',
  subtitle = '',
  width,
  height,
}: PlaceholderModel) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={' flex flex-col items-center pt-16'}>
        <img className="w-18 h-18 mb-5" src="/icons/wand.svg" alt="wand" />
        <span className="font-semibold text-lg px-10 mb-3 w-120 max-w-full text-center">
          {title || t('widget.placeholder.title')}
        </span>
        <span className="text-sm text-grey-50 px-10 w-120 max-w-full text-center">
          {subtitle || t('widget.placeholder.subtitle')}
          <br />
        </span>
      </div>
    </>
  );
};

export default PlaceholderWidget;
